import {
  JceVenueCollectionEntryEntity,
  JceVenueCollectionIconIndicator,
  JceVenueCollectionStatus,
} from '../../generated/graphql';

const SPECIAL_COLLECTION_OPTIONS = ['BOOK_TONIGHT', 'GDA', 'RECOMMENDED_FOR_YOU'] as const;
export type SpecialCollectionValue = (typeof SPECIAL_COLLECTION_OPTIONS)[number];
export { SPECIAL_COLLECTION_OPTIONS };

export type CollectionSummary = {
  id: number;
  name: string;
  shortName?: string | null;
  description?: string | null;
  iconIndicator?: JceVenueCollectionIconIndicator | null;
  status?: JceVenueCollectionStatus | null;
  urlSlug?: string | null;
  collectionEntrys?: JceVenueCollectionEntryEntity[] | [];
};

export type OrderingEntrySummary = {
  id: number;
  position?: number | null;
  specialCollection?: SpecialCollectionValue | null;
  collection?: CollectionSummary | null;
  isDesignatedForLeaderboard?: boolean | null;
};
